import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=5a0bdd87"
import script from "./authority.vue?vue&type=script&lang=js"
export * from "./authority.vue?vue&type=script&lang=js"
import style0 from "./authority.vue?vue&type=style&index=0&id=5a0bdd87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports